/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'

class Inquiry extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      modalInquiry: false
    }
  }

  componentDidMount() {}

  submit(e) {
    e.preventDefault()
  }

  barcodeChange(e) {
    let target = e.target
    let value = target.value
    let extractId = ''

    if (e.key == 'Enter') {
      if (value === '') {
        message.error('بارکد را وارد کنید')
      } else {
        // if(value.length=='16'){
        //     var extractBarcode=value.substring(5,11)
        //     var extractWeight=value.substring(11,16)
        //     extractId=extractBarcode;
        // }
        // else if(value.length=='18'){
        //     var extractBarcode=value.substring(7,13)
        //     var extractWeight=value.substring(13,18)
        //     extractId=extractBarcode;
        // }
        // else{
        //     extractId=value;
        // }
        http.get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_BY_BARCODE}?barcode=${value}`, {}).then((response) => {
          if (response.data.error === null) {
            this.setState({
              data: response.data.object,
              modalInquiry: !this.state.modalInquiry
            })
            e.preventDefault()
            target.value = ''
          } else {
            message.error(response.data.description)
            e.preventDefault()
            target.value = ''
          }
        })
      }
    }
  }

  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }

  toggle = () => {
    this.setState({
      modalInquiry: !this.state.modalInquiry
    })
  }

  inquiry() {
    let value = document.getElementById('barcode').value.trim()
    let extractId = ''

    if (value === '') {
      message.error('بارکد را وارد کنید')
    } else {
      // if(value.length=='16'){
      //     var extractBarcode=value.substring(5,11)
      //     var extractWeight=value.substring(11,16)
      //     extractId=extractBarcode;
      // }
      // else if(value.length=='18'){
      //     var extractBarcode=value.substring(7,13)
      //     var extractWeight=value.substring(13,18)
      //     extractId=extractBarcode;
      // }
      // else{
      //     extractId=value;
      // }
      http.get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_BY_BARCODE}?barcode=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            data: response.data.object,
            modalInquiry: !this.state.modalInquiry
          })
          document.getElementById('barcode').value = ''
        } else {
          message.error(response.data.description)
          document.getElementById('barcode').value = ''
        }
      })
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>استعلام فاکتور</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>استعلام فاکتور</p>
            </div>

            <div className="formComponent">
              <label>بارکد :‌</label>
              <input
                type="text"
                onKeyPress={this.barcodeChange.bind(this)}
                className="form-control"
                id="barcode"
                name="barcode"
              />
            </div>
            <div className="formComponent">
              {/*<button className='btn btn-info btn-block jasperBtn' onClick={this.inquiry.bind(this)}>استعلام*/}
              {/*</button>*/}
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
        <Modal isOpen={this.state.modalInquiry} toggle={this.toggle} size="md">
          <ModalHeader toggle={this.toggle}>اطلاعات</ModalHeader>
          <ModalBody>
            <table className="baseTable">
              <tr className="firstRow">
                <td>ردیف</td>
                <td>تاریخ</td>
                <td>بازه</td>
                <td>زمان تحویل</td>

                <td>شناسه فاکتور</td>
                <td>شماره فاکتور</td>
                <td>خریدار</td>
                <td>تحویل گیرنده</td>
                <td>رساننده</td>
                <td>وضعیت</td>
              </tr>
              {this.state.data.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                  <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                  <td>{items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>{items.invoice.buyerName}</td>
                  <td>{items.invoice.recipientName}</td>
                  <td>{items.driver == null ? '-' : items.driver.name}</td>
                  <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                </tr>
              ))}
            </table>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.toggle}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default Inquiry
